import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { Profile } from './profile-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { Role } from './role-entity';
import { Branch } from '../control-tables/branch-entity';



export class Person extends BaseEntity {

    login               : string;
    personCode          : string;
    firstName           : string;
    name                : string;
    branchCode          : string;
    branch              : Branch    = new Branch();
    profile             : Profile   = new Profile();
    role                : Role      = new Role();
    cellularPhone       : string;
    email               : string;
    longitude           : number;
    latitude            : number;

    completeName        : string;

    token               : string;

    point               : marker;
}